import { render, staticRenderFns } from "./Myprofile.vue?vue&type=template&id=9a2ed0c2"
import script from "./Myprofile.vue?vue&type=script&lang=js"
export * from "./Myprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports